module.exports = __webpack_public_path__ + "img/heart.a8e82225.svg";